export default __webpack_public_path__ + "static/media/help-rav-inv-11.eec0fd42.png";